import { Modal, Typography } from 'antd'
import { Cancel } from 'components/UI'
import React from 'react'
import { useIntl } from 'react-intl'
import ShiftHistoryDetail from '../ShiftHistory/ShiftHistoryDetail'

const { Text } = Typography

const CloseShiftSuccess = ({ onCancel, data, ...props }) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      title={
        <Text style={{ fontSize: 16 }} strong>
          {formatMessage({ id: 'close_shift_success' })}
        </Text>
      }
      destroyOnHidden
      footer={<Cancel onClick={onCancel} title={formatMessage({ id: 'button.close' })} />}
      width={800}
      onCancel={onCancel}
      styles={{ body: { height: 'calc(100vh - 200px)', overflowY: 'scroll' } }}
      {...props}
    >
      <ShiftHistoryDetail data={data} title={formatMessage({ id: 'shift_detail' })} />
    </Modal>
  )
}

export default CloseShiftSuccess
